module.exports = __webpack_public_path__ + "img/randstad.4a4a2660.svg";